import { IAuthState } from './auth.constant';

const authState: IAuthState = {
    isShowSignIn: false,
    dataLogin: {},
    accountSelected :{}
};
export default authState;
